<template>
  <div>
    <div class="d-flex">
      <div class="field col-6 col-md-4">Nombre documento:</div>
      <div class="values col-6">{{ data.nombre }}</div>
    </div>
    <div class="d-flex">
      <div class="field col-6 col-md-4">Número:</div>
      <div class="values col-6">{{ data.numero }}</div>
    </div>
    <div class="d-flex">
      <div class="field col-6 col-md-4">Hora y Fecha inicio del proceso:</div>
      <div class="values col-6">{{ data.fecha_inicio_proceso.replace(" ", " a las ") }}</div>
    </div>
    <div class="d-flex">
      <div class="field col-6 col-md-4">Hora y Fecha creación:</div>
      <div class="values col-6">{{ data.fecha_creacion.replace(" ", " a las ") }}</div>
    </div>
    <div class="d-flex">
      <div class="field col-6 col-md-4">Hora y Fecha actualización:</div>
      <div class="values col-6">{{ data.fecha_actualizacion.replace(" ", " a las ") }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoDnt',
  props: ['formatNumber', 'data']
};
</script>
<style scoped>
.field {
  font-weight: bold;
}
</style>
